import React from 'react';
import { TopBarChatButtonStyle as S } from './TopBarChatButton.style';
import { PTooltip } from 'components/prime/PTooltip/PTooltip';
import { useHasFF } from 'stores/ff.store';
import { Link } from 'react-router';

export const TopBarChatButton: React.FC = () => {
  const hasChatFF = useHasFF('ff-chat');
  return hasChatFF ? (
    <S.Container className="top-bar-chat-button" data-testid="icon-top-bar-gen-chat">
      <Link to="/gen">
        <S.YabbleGenAvatar />
      </Link>
      <PTooltip target={`.top-bar-chat-button`} position="bottom" my="center top+4" content="Chat with Gen" />
    </S.Container>
  ) : null;
};
